import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'dm-card-edit-modal',
  templateUrl: './dm-card-edit-modal.component.html',
  styleUrls: ['./dm-card-edit-modal.component.scss']
})
export class DmCardEditModal implements OnInit {

  public loader           = false;
  public servico          = null;
  public configuracaoLoja = null;
  public cartService      = null;

  constructor(
    public dialog: MatDialogRef<DmCardEditModal>,
    @Inject(MAT_DIALOG_DATA) public data
  ){ 

    this.servico          = this.data.servico;
    this.configuracaoLoja = this.data.configuracaoLoja;   
    this.cartService      = this.data.cartService;

  }
  /***
  * 
  * Close
  * 
  */
  _close(){
    this.dialog.close(); 
  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{



  }

}
